import React, { Component } from "react";
import { connect } from "react-redux";
import CarrierForm from "./_CarrierForm";
import OrderForm from "./_OrderForm";
import ShipmentForm from "./_ShipmentForm";
import RelationForm from "./_RelationForm";
import ShipmentAttachmentsDialog from './_ShipmentAttachmentsDialog'
import OrderAttachmentsDialog from './_OrderAttachmentsDialog'
import ShipmentStatusCallout from './_ShipmentStatusCallout'
import RelationModalForm from './_RelationModalForm'



class Forms extends Component {
  render() {
    const { addOrEdit, formName } = this.props.ui;

    return (
      //TODO  move form props inside the forms
      <div>
        
        <CarrierForm visible={formName === "carrier"} addOrEdit={addOrEdit} />
        <OrderForm visible={formName === "order"} addOrEdit={addOrEdit} />
        <ShipmentForm visible={formName === "shipment"} addOrEdit={addOrEdit} />
        {/* <RelationForm visible={formNamore === "relation"} addOrEdit={addOrEdit} /> */}
        <ShipmentAttachmentsDialog />
        <OrderAttachmentsDialog />
        <ShipmentStatusCallout />
        <RelationModalForm visible={formName === "relation"} addOrEdit={addOrEdit} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ui: state.ui
  };
};

export default connect(mapStateToProps)(Forms);



// WEBPACK FOOTER //
// ./src/common/Forms/index.js